import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import * as Common from 'common/components';
import Validated from 'components/util/Validated';

const { Form } = Common;

const InpcForm = ({
  company,
  errors,
  handleAddCustomField,
  handleRemoveCustomField,
  handleSubmit,
  handleValueChange,
  isSaving,
  isSubmitted,
  t,
  values,
}) => {
  console.log(isSaving);
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <div className="col-md-12 mt-3 table-responsive">
        <Common.Table bordered>
          <thead>
            <tr>
              <th>{t('inpc.fields.year')}</th>
              <th>{t('months.1')}</th>
              <th>{t('months.2')}</th>
              <th>{t('months.3')}</th>
              <th>{t('months.4')}</th>
              <th>{t('months.5')}</th>
              <th>{t('months.6')}</th>
              <th>{t('months.7')}</th>
              <th>{t('months.8')}</th>
              <th>{t('months.9')}</th>
              <th>{t('months.10')}</th>
              <th>{t('months.11')}</th>
              <th>{t('months.12')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-center input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors.year) || {}}
                  name={'year'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);

                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.year}
                />
              </td>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-right input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors["values['1']"]) || {}}
                  name={'values.1'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);
                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.values['1']}
                />
              </td>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-right input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors["values['2']"]) || {}}
                  name={'values.2'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);
                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.values['2']}
                />
              </td>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-right input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors["values['3']"]) || {}}
                  name={'values.3'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);
                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.values['3']}
                />
              </td>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-right input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors["values['4']"]) || {}}
                  name={'values.4'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);
                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.values['4']}
                />
              </td>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-right input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors["values['5']"]) || {}}
                  name={'values.5'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);
                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.values['5']}
                />
              </td>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-right input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors["values['6']"]) || {}}
                  name={'values.6'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);
                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.values['6']}
                />
              </td>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-right input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors["values['7']"]) || {}}
                  name={'values.7'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);
                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.values['7']}
                />
              </td>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-right input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors["values['8']"]) || {}}
                  name={'values.8'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);
                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.values['8']}
                />
              </td>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-right input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors["values['9']"]) || {}}
                  name={'values.9'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);
                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.values['9']}
                />
              </td>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-right input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors["values['10']"]) || {}}
                  name={'values.10'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);
                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.values['10']}
                />
              </td>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-right input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors["values['11']"]) || {}}
                  name={'values.11'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);
                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.values['11']}
                />
              </td>
              <td>
                <Form.FieldInput
                  type="number"
                  className="text-right input-table"
                  inputSize="sm"
                  error={(isSubmitted && errors["values['12']"]) || {}}
                  name={'values.12'}
                  handleChange={(e) => {
                    const value = Number.isNaN(parseFloat(e.target.value))
                      ? ''
                      : parseFloat(e.target.value);
                    const name = e.target.name;
                    handleValueChange({ target: { name, value } });
                  }}
                  t={t}
                  value={values.values['12']}
                />
              </td>
            </tr>
          </tbody>
        </Common.Table>
      </div>

      <div className="col-md-12 mt-3">
        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={`/companies/${company.id}/inpc`}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated({
  type: 'object',
  properties: {
    year: {
      type: 'number',
    },
    values: {
      type: 'object',
      properties: {
        1: {
          type: 'number',
        },
        2: {
          type: 'number',
        },
        3: {
          type: 'number',
        },
        4: {
          type: 'number',
        },
        5: {
          type: 'number',
        },
        6: {
          type: 'number',
        },
        7: {
          type: 'number',
        },
        8: {
          type: 'number',
        },
        9: {
          type: 'number',
        },
        10: {
          type: 'number',
        },
        11: {
          type: 'number',
        },
        12: {
          type: 'number',
        },
      },
      required: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
    },
  },
  required: ['year', 'values'],
})(translate()(InpcForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/components/form/InpcForm.js